import styled from 'styled-components';
import { Styling, Colors } from '../../../constants';

export const SettingsMenuContainer = styled.div`
  margin-top: ${Styling.DEFAULT_SPACING_HALVED}px;
  * {
    color: ${Colors.WHITE_100};
  }
  svg {
    font-size: 1.25rem;
    margin-top: -${Styling.DEFAULT_SPACING_HALVED}px;
  }
`;
